import { clsx } from 'clsx'
import { type FC, type HTMLAttributes } from 'react'

import { type SelectionEntry } from '../../../../product-page-context/AttributeGroup'

type ProductPageColorTypeAttributeHeadProps = HTMLAttributes<HTMLDivElement> & {
  selectionEntry: SelectionEntry
}

export const ProductPageColorTypeAttributePreview: FC<
  ProductPageColorTypeAttributeHeadProps
> = (props) => {
  const {
    className,
    selectionEntry: { attribute, isSelected },
  } = props

  const entryHexColor = attribute.hex?.toLowerCase()

  if (!entryHexColor) {
    return null
  }

  return (
    <div
      className={clsx(
        'mr-2.5 inline-block size-6 rounded-full border align-middle',
        // We should cover all light colors not only white with this approach
        (entryHexColor === '#fff' || entryHexColor === '#ffffff') && !isSelected
          ? 'border-dark-primary-strong'
          : 'border-light-primary-strong',
        className,
      )}
      style={{ backgroundColor: entryHexColor }}
    />
  )
}
